// ** Icon imports
import InventoryIcon from 'mdi-material-ui/BoxCutterOff'
import HomeOutline from 'mdi-material-ui/HomeOutline'
import MoveUpIcon from 'mdi-material-ui/MouseMoveUp'
import DomainIcon from 'mdi-material-ui/Domain'
import PrecisionManufacturingIcon from 'mdi-material-ui/SlotMachine'

// ** Type import
import { VerticalNavItemsType } from 'src/@core/layouts/types'
import { FileCertificateOutline, WrenchClock } from 'mdi-material-ui'

const navigation = (): VerticalNavItemsType => {
  return [
    {
      title: 'Dashboard',
      icon: HomeOutline,
      path: '/',
    },
    {
      title: 'Servisler',
      icon: WrenchClock,
      path: '/services',
    },
    {
      title: 'Firma Listesi',
      icon: DomainIcon,
      path: '/company',
    },
    {
      title: 'Firma Listesi (Detaylı)',
      icon: DomainIcon,
      path: '/company-indetail',
    },
    {
      title: 'Parça Listesi',
      icon: InventoryIcon,
      path: '/stock',
    },
    {
      title: 'Parça Hareketleri',
      icon: MoveUpIcon,
      path: '/stock-move',
    },
    {
      title: 'Makineler',
      icon: PrecisionManufacturingIcon,
      path: '/machine',
    },
    {
      title: 'Makine Hareketleri',
      icon: MoveUpIcon,
      path: '/machine-moves',
    },
    {
      title: 'Dosyalar',
      icon: FileCertificateOutline,
      path: '/files',
    },
  ]
}

export default navigation
